import * as React from 'react';

export default function renderDefaultProviderIcon(
): React.ReactElement<void> {
  const src = require('images/edge-icons/self_report.png');
  return <img src={src} className="edge-provider-icon"/>
}
